<main class="content">
    <div class="content-wrapper">
        <div class="content-body">
            <div class="maintenance-txt">Ведутся запланированные технические работы.</div>
            <div class="maintenance-txt">Попробуйте позже.</div>
        </div>
    </div>
</main>
